import {
  ClientTool,
  ClientToolBase,
  ClientToolWithHandler,
  ClientToolWithInputSchema,
  ClientToolWithRender,
  ClientToolWithRenderAndWaitForResponse,
  ServerTool,
} from "./type";
import type { Schema } from "@ag-kit/shared";

export function clientTool<TSchema extends Schema>(
  tool: ClientToolBase<TSchema>
): ClientToolWithInputSchema<TSchema>;
export function clientTool<TSchema extends Schema>(
  tool: ClientToolWithHandler<TSchema>
): ClientToolWithInputSchema<TSchema>;
export function clientTool<TSchema extends Schema>(
  tool: ClientToolWithRender<TSchema>
): ClientToolWithInputSchema<TSchema>;
export function clientTool<TSchema extends Schema>(
  tool: ClientToolWithRenderAndWaitForResponse<TSchema>
): ClientToolWithInputSchema<TSchema>;
export function clientTool<TSchema extends Schema>(tool: ClientTool<TSchema>) {
  return tool;
}

export function isClientToolWithHandler<TSchema extends Schema>(
  tool: ClientToolWithInputSchema<TSchema>
): tool is ClientToolWithHandler<TSchema> {
  return "handler" in tool;
}

export function isClientToolWithRender<TSchema extends Schema>(
  tool: ClientToolWithInputSchema<TSchema>
): tool is ClientToolWithRender<TSchema> {
  return "render" in tool;
}

export function isClientToolWithRenderAndWaitForResponse<
  TSchema extends Schema,
>(
  tool: ClientToolWithInputSchema<TSchema>
): tool is ClientToolWithRenderAndWaitForResponse<TSchema> {
  return "renderAndWaitForResponse" in tool;
}

export function serverTool<TSchema extends Schema>(
  tool: ServerTool<TSchema>
): ServerTool<TSchema> {
  return tool;
}
